import "./Home.module.css";
import CompanyHeader from "@/reusable_sections/Header";
import UnleashYourAcademicVoice from "./sections/UnleashYourAcademicVoice";
import AdministrativeWorkflow from "./sections/AdministrativeWorkflow";
import LearningPathways from "./sections/LearningPathways";
import ModuleCapabilities from "./sections/ModuleCapabilities";
import ReserveYourExperience from "./sections/ReserveYourExperience";
import DriveWithDistinction from "./sections/DriveWithDistinction";
import OurGlobalFootprint from "./sections/OurGlobalFootprint";
import ComprehensiveFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <CompanyHeader />
      <UnleashYourAcademicVoice />
      <AdministrativeWorkflow />
      <LearningPathways />
      <ModuleCapabilities />
      <ReserveYourExperience />
      <DriveWithDistinction />
      <OurGlobalFootprint />
      <ComprehensiveFooter />
    </div>;
}